import React from "react";

// SPINLAB wordmark — ultra-thin letterspaced text.
// Pure typography. No decorative arch (per brand owner instruction).
const Logo = ({ size = "md", className = "", testId = "spinlab-logo" }) => {
  const dims = {
    sm: { text: "text-sm", tag: "text-[8px]", line: "w-full" },
    md: { text: "text-lg", tag: "text-[9px]", line: "w-full" },
    lg: { text: "text-3xl sm:text-5xl", tag: "text-xs", line: "w-full" },
    xl: { text: "text-5xl sm:text-7xl md:text-8xl", tag: "text-sm", line: "w-full" },
  }[size];

  return (
    <div
      data-testid={testId}
      className={`inline-flex flex-col items-center select-none ${className}`}
    >
      <span
        className={`font-display font-extralight uppercase tracking-brand text-white ${dims.text} leading-none`}
      >
        SPINLAB
      </span>
      <span className={`hairline ${dims.line} my-2`} aria-hidden="true" />
      <span
        className={`font-display font-light uppercase tracking-[0.3em] text-gray-400 ${dims.tag}`}
      >
        Auto Detailing
      </span>
    </div>
  );
};

export default Logo;
